import { animated, useTransition } from "@react-spring/web";
import type { FunctionComponent } from "react";

import { tracking } from "shared/data";
import { useCurrentPageType } from "shared/hooks";

import { useSwapOnScrollEffect } from "scmp-app/components/header/hooks";
import {
  Container,
  LogoContainer,
  LogoLink,
  StyledHeaderActions,
  StyledLogoLearn,
  StyledLogoPosties,
  Wrapper,
} from "scmp-app/components/posties/header/common/styles";
import { page as PostiesPage } from "scmp-app/pages/posties";

import { StyledHeaderMenu } from "./styles";

export type Props = {
  className?: string;
};

export const PostiesBrochureHeader: FunctionComponent<Props> = ({ className }) => {
  const { shouldSwap } = useSwapOnScrollEffect(150);

  const transitions = useTransition(shouldSwap, {
    enter: {
      display: "block",
      opacity: 1,
      transform:
        "translate3d(0px, 0%, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
    },
    from: {
      opacity: 0,
      transform:
        "translate3d(0px, 100%, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
    },
    initial: {
      display: "block",
      opacity: 1,
    },
    leave: {
      display: "none",
      opacity: 0,
      transform:
        "translate3d(0px, -100%, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
    },
  });

  const { pathname, query } = PostiesPage.route({});

  const currentPageType = useCurrentPageType();
  const postiesHeaderQueryParameters = {
    module: tracking.module.HeaderPosties,
    pgtype: currentPageType,
  };

  return (
    <Container className={className}>
      <Wrapper>
        <LogoContainer>
          {transitions((style, shouldSwap) => (
            <animated.div style={style}>
              {shouldSwap ? (
                <LogoLink pathname={pathname} query={{ ...query, ...postiesHeaderQueryParameters }}>
                  <StyledLogoPosties />
                </LogoLink>
              ) : (
                <StyledLogoLearn />
              )}
            </animated.div>
          ))}
        </LogoContainer>
        <StyledHeaderMenu />
        <StyledHeaderActions />
      </Wrapper>
    </Container>
  );
};

PostiesBrochureHeader.displayName = "PostiesBrochureHeader";
